import { FlatList, Pressable, StyleSheet, View, type ListRenderItemInfo } from 'react-native';
import { ChevronRight } from 'lucide-react-native';
import type { ProfileActionViewModel } from '../../types/profile';
import { tokens } from '../../theme/tokens';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type ProfileActionListProps = {
  actions: ProfileActionViewModel[];
  onPressAction: (action: ProfileActionViewModel) => void;
};

export function ProfileActionList({ actions, onPressAction }: ProfileActionListProps) {
  const renderAction = ({ item }: ListRenderItemInfo<ProfileActionViewModel>) => (
    <Pressable
      accessibilityRole="button"
      onPress={() => onPressAction(item)}
      style={({ pressed }) => [pressed ? styles.pressed : null]}
    >
      <AppCard style={styles.actionCard}>
        <View style={styles.copy}>
          <AppText variant="body" weight="bold">
            {item.title}
          </AppText>
          <AppText variant="caption" tone="muted">
            {item.description}
          </AppText>
        </View>
        <ChevronRight size={18} color={tokens.colors.textSubtle} />
      </AppCard>
    </Pressable>
  );

  return (
    <FlatList
      data={actions}
      keyExtractor={(action) => action.id}
      renderItem={renderAction}
      scrollEnabled={false}
      ItemSeparatorComponent={Separator}
    />
  );
}

function Separator() {
  return <View style={styles.separator} />;
}

const styles = StyleSheet.create({
  pressed: {
    opacity: 0.86,
  },
  actionCard: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.md,
  },
  copy: {
    flex: 1,
    gap: tokens.spacing.xs,
  },
  separator: {
    height: tokens.spacing.md,
  },
});
